export default "__VITE_ASSET__4xQMv05o__"